import React from 'react';
import { Form, Col, Row, Input } from 'antd';
import '../App.css';
import 'antd/dist/antd.css'; 
import 'moment/locale/es';

//Seleccionar regimenes en los que aportaste
const {Item} = Form;

function App() {

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 8,
    },
  };

  return (

    <div>

     <Row>
        <Col xs={1} sm={1} md={2} lg={5} ></Col>

        <Col xs={22} sm={22} md={20} lg={14} >

          <Form name="formulario" {...layout}>                                                  
                                    
              <Item name="actual" label="Actuales"  rules={[{required:true,message:"Por favor complete sus ingresos actuales "}]}> <Input style={{ width: 200}}  prefix="$" suffix="ARS" placeholder=' Ingresos' name='IngresoActual'/> </Item>
              <Item name="alos55" label="A los 55 años"  rules={[{required:true,message:"Por favor complete sus ingresos a los 55 años"}]}> <Input style={{ width: 200}}  prefix="$" suffix="ARS" placeholder=' Ingresos' name='Ingreso55'/></Item>
              <Item name="alos65" label="A los 65 años"  rules={[{required:true,message:"Por favor complete sus ingresos a los 65 años"}]}> <Input style={{ width: 200}}  prefix="$" suffix="ARS" placeholder=' Ingresos' name='Ingreso55'/></Item>

          </Form>

        </Col>

        <Col xs={1} sm={1} md={2} lg={5} ></Col>
     </Row>
    </div>

);}

export default App;